import { render, staticRenderFns } from "./DeleteIncompleteArchivesDialogBox.vue?vue&type=template&id=912c50e8&scoped=true&"
import script from "./DeleteIncompleteArchivesDialogBox.vue?vue&type=script&lang=js&"
export * from "./DeleteIncompleteArchivesDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912c50e8",
  null
  
)

export default component.exports